/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const RECEIVE_STREAM_CHANNELS = '@@nzr/stream/RECEIVE_STREAM_CHANNELS'
export const SET_FETCHED_UNFILTERED_CHANNELS = '@@nzr/stream/SET_FETCHED_UNFILTERED_CHANNELS'
export const SET_FETCHING_STREAM_CONVERSATIONS = '@@nzr/stream/SET_FETCHING_STREAM_CONVERSATIONS'
export const SET_FETCHING_UNFILTERED_CHANNELS = '@@nzr/stream/SET_FETCHING_UNFILTERED_CHANNELS'
export const SET_UNREAD_COUNTS = '@@nzr/stream/SET_UNREAD_COUNTS'
